/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, styled } from '@mui/material';

export const AppWithoutLayoutContainer = styled(Box)`
  width: 100vw;
  height: 100vh;
  margin: auto;
  display: flex;
  flex-direction: column;
`;
export const AppWithoutLayout = styled(Box)`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 18px;
  max-width: 1920px;
  margin-top: var(--safe-area-statusbarHeight);
`;
